var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.60156,
    cy: 9,
    r: 7,
    fill: "#777777"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60156 2.25C7.71514 2.25 6.8374 2.42459 6.01845 2.76381C5.1995 3.10303 4.45539 3.60023 3.82859 4.22703C3.2018 4.85382 2.70459 5.59794 2.36538 6.41689C2.02616 7.23583 1.85156 8.11358 1.85156 9C1.85156 9.88642 2.02616 10.7642 2.36538 11.5831C2.70459 12.4021 3.2018 13.1462 3.82859 13.773C4.45539 14.3998 5.1995 14.897 6.01845 15.2362C6.8374 15.5754 7.71514 15.75 8.60156 15.75C10.3918 15.75 12.1087 15.0388 13.3745 13.773C14.6404 12.5071 15.3516 10.7902 15.3516 9C15.3516 7.20979 14.6404 5.4929 13.3745 4.22703C12.1087 2.96116 10.3918 2.25 8.60156 2.25ZM0.351562 9C0.351562 4.44375 4.04531 0.75 8.60156 0.75C13.1578 0.75 16.8516 4.44375 16.8516 9C16.8516 13.5562 13.1578 17.25 8.60156 17.25C4.04531 17.25 0.351562 13.5562 0.351562 9ZM7.47656 5.25V12.75H5.97656V5.25H7.47656ZM11.2266 5.25V12.75H9.72656V5.25H11.2266Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31585 5V13H5.60156V5H7.31585ZM11.6016 5V13H9.88728V5H11.6016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBtn);
export default __webpack_public_path__ + "static/media/pause-btn.95705ead89a816f80bc3ff14f837b0d7.svg";
export { ForwardRef as ReactComponent };